(function () {
  'use strict';

  function formatMoney(amount) {
    if (amount == null || amount === '') return '$0.00';

    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      var raw = amount;
      if (typeof raw === 'string' && raw.indexOf('.') !== -1) {
        raw = raw.replace('.', '');
      }
      return window.theme.Currency.formatMoney(raw);
    }

    var num = typeof amount === 'number' ? amount : parseFloat(String(amount).replace(/[^0-9.-]+/g, ''));
    if (isNaN(num)) return '$0.00';
    if (num > 500 && String(amount).indexOf('.') === -1) {
      num = num / 100;
    }
    return '$' + num.toFixed(2);
  }

  function determineCategory(stepId, stepTitle, label, groupHeading) {
    if (groupHeading && groupHeading.trim()) {
      return groupHeading.trim();
    }

    var sId = (stepId || '').toLowerCase();
    var title = (stepTitle || '').toLowerCase();
    var lbl = (label || '').toLowerCase();

    // 1. Projects / Garment Type
    if (sId.indexOf('cloth') !== -1 || sId.indexOf('garment') !== -1 || sId.indexOf('project') !== -1 || title.indexOf('garment') !== -1 || title.indexOf('project') !== -1) {
      return 'Projects';
    }

    // 2. Color Family
    if (sId.indexOf('color') !== -1 || title.indexOf('color') !== -1 || title.indexOf('shade') !== -1) {
      return 'Color Family';
    }

    // 3. Pattern
    if (sId.indexOf('pattern') !== -1 || title.indexOf('pattern') !== -1 || title.indexOf('print') !== -1) {
      return 'Pattern';
    }

    // 4. Embellishment
    if (sId.indexOf('embellish') !== -1 || title.indexOf('embellish') !== -1) {
      return 'Embellishment';
    }

    // 5. Check if the option label itself is explicitly a price filter
    if (sId === 'price' || /under|\$|\d+\s*–|\d+\s*-\s*\$|\bprice\b/i.test(lbl)) {
      return 'Price Range';
    }

    // 5. Fabric Type
    if (lbl === 'natural' || lbl === 'synthetic' || lbl === 'blended' || lbl.indexOf('sustainable') !== -1) {
      return 'Fabric Type';
    }

    // 6. Preferences
    if (sId.indexOf('pref') !== -1 || title.indexOf('pref') !== -1 || title.indexOf('feature') !== -1) {
      return 'Preferences';
    }

    var cleanTitle = (stepTitle || 'Filter')
      .replace(/\?+/g, '')
      .replace(/^(what|which|choose|pick|select)\s+(type\s+of\s+|your\s+)?/i, '')
      .trim();

    return cleanTitle ? (cleanTitle.charAt(0).toUpperCase() + cleanTitle.slice(1)) : 'Filter';
  }

  function initQuiz(root) {
    if (root._fqInit) return;
    root._fqInit = true;

    var quizView       = root.querySelector('[data-quiz-view]');
    var resultsView    = root.querySelector('[data-quiz-results-view]');
    var steps          = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    if (!steps.length) return;

    var bar            = root.querySelector('[data-quiz-bar]');
    var dots           = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-dots] .fabric-quiz__dot'));
    var stepLabel      = root.querySelector('[data-quiz-steplabel]');
    var backBtn        = root.querySelector('[data-quiz-back]');
    var nextBtn        = root.querySelector('[data-quiz-next]');
    var summaryEl      = root.querySelector('[data-quiz-summary]');
    var answersEl      = root.querySelector('[data-quiz-answers]');
    var form           = root.querySelector('.fabric-quiz__form');

    /* Results Elements */
    var sidebarPillsEl = root.querySelector('[data-quiz-active-tags]');
    var productsGridEl = root.querySelector('[data-quiz-products-grid]');
    var countTextEl    = root.querySelector('[data-quiz-count-text]');
    var clearAllBtn    = root.querySelector('[data-quiz-clear-all]');
    var retakeBtn      = root.querySelector('[data-quiz-retake]');
    var sortWrapper    = root.querySelector('[data-quiz-sort-wrapper]');
    var sortToggleBtn  = root.querySelector('[data-quiz-sort-toggle]');
    var sortLabelEl    = root.querySelector('[data-quiz-sort-label]');
    var sortMenuEl     = root.querySelector('[data-quiz-sort-menu]');
    var sortOptions    = root.querySelectorAll('.fabric-quiz__sort-option');
    var sortSelect     = root.querySelector('[data-quiz-sort]');
    var loadingEl      = root.querySelector('[data-quiz-loading]');
    var emptyStateEl   = root.querySelector('[data-quiz-empty-state]');
    var emptyResetBtn  = root.querySelector('[data-quiz-empty-reset]');

    var metafieldsDataEl = root.querySelector('[data-quiz-metafields-json]');
    var productMetafieldsMap = {};
    if (metafieldsDataEl) {
      try {
        productMetafieldsMap = JSON.parse(metafieldsDataEl.textContent || '{}');
      } catch (e) {}
    }

    var collectionHandle = root.getAttribute('data-collection-handle') || 'all';

    var total   = steps.length;
    var current = 0;

    var allProducts = [];
    var activeFilterItems = []; /* Array of { id, sid, category, value, label } */
    var productsLoaded = false;
    var currentSort = 'featured';

    /* =========================================================================
       1. STEP OPTION SELECTION & VALIDATION
       ========================================================================= */

    function bindOptions(step) {
      var mode = step.getAttribute('data-select-mode') || 'multi';
      var max  = parseInt(step.getAttribute('data-max'), 10);
      var options = step.querySelectorAll('[data-option]');

      Array.prototype.forEach.call(options, function (opt) {
        opt.addEventListener('click', function () {
          hideHint(step);
          if (mode === 'single') {
            Array.prototype.forEach.call(options, function (o) { o.classList.remove('is-selected'); });
            opt.classList.add('is-selected');
            return;
          }
          /* multi */
          if (!opt.classList.contains('is-selected')) {
            if (max && step.querySelectorAll('[data-option].is-selected').length >= max) {
              flashLimit(step);
              showHint(step, null, max);
              return;
            }
          }
          hideHint(step);
          opt.classList.toggle('is-selected');
        });
      });
    }

    function flashLimit(step) {
      step.classList.remove('fq-shake');
      void step.offsetWidth;
      step.classList.add('fq-shake');
    }

    function bindSliders(step) {
      var sliders = step.querySelectorAll('[data-slider-input]');
      Array.prototype.forEach.call(sliders, function (input) {
        var valueEl = input.closest('[data-slider]').querySelector('[data-slider-value]');
        function update() {
          if (valueEl) valueEl.textContent = input.value;
        }
        input.addEventListener('input', update);
        update();
      });
    }

    steps.forEach(function (step) {
      try { bindOptions(step); } catch (e) {}
      try { bindSliders(step); } catch (e) {}
    });

    function showHint(step, missingGroupName, maxLimit) {
      var hint = step.querySelector('.fabric-quiz__hint');
      if (!hint) {
        hint = document.createElement('div');
        hint.className = 'fabric-quiz__hint';
        step.appendChild(hint);
      }
      if (maxLimit) {
        hint.textContent = 'You can select up to ' + maxLimit + ' options.';
      } else if (missingGroupName) {
        hint.textContent = 'Please select at least one option in "' + missingGroupName + '" to continue.';
      } else {
        hint.textContent = root.getAttribute('data-required-msg') || 'Please select at least one option to continue.';
      }
      hint.style.display = 'block';
    }

    function hideHint(step) {
      var hint = step.querySelector('.fabric-quiz__hint');
      if (hint) hint.style.display = 'none';
    }

    function checkStepValidation(step) {
      var required = step.getAttribute('data-required') === 'true';
      if (!required) return { valid: true };
      if (step.getAttribute('data-step-type') === 'results') return { valid: true };
      var allOptions = Array.prototype.slice.call(step.querySelectorAll('[data-option]'));
      if (!allOptions.length) return { valid: true };

      // Check if step has multiple distinct groups
      var groups = {};
      allOptions.forEach(function (opt) {
        var gh = (opt.getAttribute('data-group-heading') || '').trim();
        if (gh) {
          if (!groups[gh]) groups[gh] = [];
          groups[gh].push(opt);
        }
      });

      var groupNames = Object.keys(groups);
      if (groupNames.length > 1) {
        // Must select at least one option in every group
        for (var i = 0; i < groupNames.length; i++) {
          var gName = groupNames[i];
          var anySelected = groups[gName].some(function (opt) {
            return opt.classList.contains('is-selected');
          });
          if (!anySelected) {
            return { valid: false, missingGroup: gName };
          }
        }
        return { valid: true };
      }

      var isValid = step.querySelectorAll('[data-option].is-selected').length > 0;
      return { valid: isValid };
    }

    function isStepValid(step) {
      return checkStepValidation(step).valid;
    }

    /* Collect all user answers grouped by step */
    function collectSelectedFilterItems() {
      var items = [];
      steps.forEach(function (step) {
        if (step.getAttribute('data-step-type') === 'results') return;
        var sid = step.getAttribute('data-step-id') || ('step_' + step.getAttribute('data-step-index'));
        var stepTitle = step.getAttribute('data-step-title') || 'Step';

        Array.prototype.forEach.call(step.querySelectorAll('[data-option].is-selected'), function (o) {
          var rawVal = o.getAttribute('data-value') || o.getAttribute('data-label') || '';
          var rawLabel = o.getAttribute('data-label') || rawVal;
          var groupHeading = o.getAttribute('data-group-heading') || '';

          /* Handle compound options like "Circles + Polka Dots" -> split into separate pills */
          if (rawLabel.indexOf(' + ') !== -1 && (sid.indexOf('pattern') !== -1 || sid.indexOf('color') !== -1)) {
            var parts = rawLabel.split(' + ');
            parts.forEach(function (part) {
              var trimmed = part.trim();
              if (trimmed) {
                var cat = determineCategory(sid, stepTitle, trimmed, groupHeading);
                items.push({
                  id: sid + '_' + trimmed.toLowerCase().replace(/[^a-z0-9]+/g, '_'),
                  sid: sid,
                  category: cat,
                  value: trimmed,
                  label: trimmed,
                  sourceOption: o
                });
              }
            });
          } else {
            var cat = determineCategory(sid, stepTitle, rawLabel, groupHeading);
            items.push({
              id: sid + '_' + rawVal.toLowerCase().replace(/[^a-z0-9]+/g, '_'),
              sid: sid,
              category: cat,
              value: rawVal,
              label: rawLabel,
              sourceOption: o
            });
          }
        });

        Array.prototype.forEach.call(step.querySelectorAll('[data-slider-input]'), function (input) {
          var sliderName = input.getAttribute('data-slider-name') || 'Preference';
          var cleanSliderCat = sliderName.split('—')[0].split('-')[0].trim();
          var val = input.value;
          var displayLabel = val + '/10';
          items.push({
            id: sid + '_slider_' + (cleanSliderCat || 'preference').toLowerCase().replace(/[^a-z0-9]+/g, '_'),
            sid: sid,
            category: cleanSliderCat || 'Drape',
            value: val,
            label: displayLabel,
            isSlider: true,
            sourceOption: null
          });
        });
      });

      return items;
    }

    function buildSummary() {
      var items = collectSelectedFilterItems();
      if (summaryEl) {
        summaryEl.innerHTML = '';
        if (!items.length) {
          var empty = document.createElement('span');
          empty.className = 'fabric-quiz__profile-empty';
          empty.textContent = 'No selections yet.';
          summaryEl.appendChild(empty);
        } else {
          items.forEach(function (item) {
            var tag = document.createElement('span');
            tag.className = 'fabric-quiz__profile-tag';
            tag.textContent = item.category + ': ' + item.label;
            summaryEl.appendChild(tag);
          });
        }
      }
      if (answersEl) {
        var lines = items.map(function (item) {
          return item.category + ': ' + item.label;
        });
        answersEl.value = lines.join('\n');
      }
    }

    /* =========================================================================
       2. STEP RENDER & NAVIGATION (STEPS 1 TO 5)
       ========================================================================= */

    function renderStep(scroll) {
      steps.forEach(function (step, i) {
        step.classList.toggle('is-active', i === current);
      });

      var pct = ((current + 1) / total) * 100;
      if (bar) bar.style.width = pct + '%';

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.classList.toggle('is-done', i < current);
      });

      if (stepLabel) {
        var title = steps[current].getAttribute('data-step-title') || '';
        stepLabel.textContent = 'Step ' + (current + 1) + ' of ' + total + (title ? ' — ' + title : '');
      }

      if (backBtn) backBtn.hidden = current === 0;

      var isResultsStep = steps[current].getAttribute('data-step-type') === 'results';
      if (nextBtn) nextBtn.hidden = isResultsStep;

      if (isResultsStep) {
        buildSummary();
      }

      if (scroll) {
        try {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) {
          root.scrollIntoView();
        }
      }
    }

    function goNext() {
      var step = steps[current];
      var validation = checkStepValidation(step);
      if (!validation.valid) {
        flashLimit(step);
        showHint(step, validation.missingGroup);
        return;
      }
      hideHint(step);

      if (current < total - 1) {
        current++;
        renderStep(true);
      }
    }

    function goBack() {
      if (current > 0) {
        current--;
        renderStep(true);
      }
    }

    if (nextBtn) nextBtn.addEventListener('click', goNext);
    if (backBtn) backBtn.addEventListener('click', goBack);

    /* =========================================================================
       3. FETCHING STORE PRODUCTS
       ========================================================================= */

    function fetchProducts(callback) {
      if (productsLoaded && allProducts.length > 0) {
        if (callback) callback(allProducts);
        return;
      }

      if (loadingEl) loadingEl.style.display = 'flex';

      var endpoint = '/collections/' + (collectionHandle || 'all') + '/products.json?limit=250';

      fetch(endpoint)
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to load collection');
          return res.json();
        })
        .then(function (data) {
          allProducts = data.products || [];
          productsLoaded = true;
          if (callback) callback(allProducts);
        })
        .catch(function () {
          fetch('/products.json?limit=250')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              allProducts = d.products || [];
              productsLoaded = true;
              if (callback) callback(allProducts);
            })
            .catch(function () {
              allProducts = [];
              productsLoaded = true;
              if (callback) callback([]);
            });
        })
        .finally(function () {
          if (loadingEl) loadingEl.style.display = 'none';
        });
    }

    /* =========================================================================
       4. SHOW RESULTS TRIGGER & SIDEBAR PILLS
       ========================================================================= */

    function triggerShowResults() {
      activeFilterItems = collectSelectedFilterItems();

      try {
        var serializable = activeFilterItems.map(function(item) {
          return { id: item.id, sid: item.sid, category: item.category, value: item.value, label: item.label, isSlider: !!item.isSlider };
        });
        sessionStorage.setItem('fq_active_filters', JSON.stringify(serializable));
      } catch (e) {}

      /* Hide quiz view, reveal search results with sidebar */
      if (quizView) quizView.hidden = true;
      if (resultsView) resultsView.hidden = false;

      try {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        root.scrollIntoView();
      }

      fetchProducts(function () {
        applyFiltersAndRender();
      });
    }

    /* Sync sidebar checkboxes state based on activeFilterItems */
    function syncSidebarCheckboxes() {
      var allCheckboxes = root.querySelectorAll('[data-sidebar-filter-input]');
      Array.prototype.forEach.call(allCheckboxes, function (cb) {
        var sid = cb.getAttribute('data-step-id');
        var val = (cb.getAttribute('data-value') || '').toLowerCase().trim();
        var lbl = (cb.getAttribute('data-label') || '').toLowerCase().trim();

        var isChecked = activeFilterItems.some(function (item) {
          var itemVal = (item.value || '').toLowerCase().trim();
          var itemLbl = (item.label || '').toLowerCase().trim();
          return item.sid === sid && (itemVal === val || itemLbl === lbl);
        });

        cb.checked = isChecked;
      });
    }

    /* Render Left Sidebar Filter Pills exactly matching client reference */
    function renderSidebarPills() {
      if (!sidebarPillsEl) return;
      sidebarPillsEl.innerHTML = '';

      if (!activeFilterItems.length) {
        var emptyMsg = document.createElement('div');
        emptyMsg.className = 'fabric-quiz__no-filters-msg';
        emptyMsg.textContent = 'All fabrics shown';
        sidebarPillsEl.appendChild(emptyMsg);
        return;
      }

      activeFilterItems.forEach(function (item, index) {
        var pill = document.createElement('div');
        pill.className = 'fabric-quiz__filter-pill';

        var labelSpan = document.createElement('span');
        labelSpan.className = 'fabric-quiz__filter-pill-label';
        labelSpan.textContent = item.category + ': ' + item.label;

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'fabric-quiz__filter-pill-remove';
        removeBtn.setAttribute('aria-label', 'Remove ' + item.label);
        removeBtn.innerHTML = '&times;';

        removeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          removeFilterItem(index);
        });

        pill.appendChild(labelSpan);
        pill.appendChild(removeBtn);
        sidebarPillsEl.appendChild(pill);
      });
    }

    function removeFilterItem(index) {
      if (index >= 0 && index < activeFilterItems.length) {
        var removed = activeFilterItems[index];
        if (removed) {
          if (removed.sourceOption) {
            removed.sourceOption.classList.remove('is-selected');
          }
          var matchingStepOption = root.querySelector('[data-step][data-step-id="' + removed.sid + '"] [data-option][data-value="' + removed.value + '"]') ||
                                   root.querySelector('[data-step][data-step-id="' + removed.sid + '"] [data-option][data-label="' + removed.label + '"]');
          if (matchingStepOption) {
            matchingStepOption.classList.remove('is-selected');
          }
        }
        activeFilterItems.splice(index, 1);
        applyFiltersAndRender();
      }
    }

    /* Bind Sidebar Filter Checkboxes, Accordion Groups & Mobile Drawer */
    function bindSidebarFilters() {
      var allCheckboxes = root.querySelectorAll('[data-sidebar-filter-input]');
      Array.prototype.forEach.call(allCheckboxes, function (cb) {
        cb.addEventListener('change', function () {
          var sid = cb.getAttribute('data-step-id');
          var stepName = cb.getAttribute('data-step-name') || 'Filter';
          var rawVal = cb.getAttribute('data-value') || cb.getAttribute('data-label') || '';
          var rawLabel = cb.getAttribute('data-label') || rawVal;
          var groupHeading = cb.getAttribute('data-group-heading') || '';
          var cat = determineCategory(sid, stepName, rawLabel, groupHeading);
          var itemId = sid + '_' + rawVal.toLowerCase().replace(/[^a-z0-9]+/g, '_');

          var matchingStepOption = root.querySelector('[data-step][data-step-id="' + sid + '"] [data-option][data-value="' + rawVal + '"]') ||
                                   root.querySelector('[data-step][data-step-id="' + sid + '"] [data-option][data-label="' + rawLabel + '"]');

          if (cb.checked) {
            var exists = activeFilterItems.some(function (item) {
              return item.sid === sid && (item.value === rawVal || item.label === rawLabel);
            });
            if (!exists) {
              activeFilterItems.push({
                id: itemId,
                sid: sid,
                category: cat,
                value: rawVal,
                label: rawLabel,
                sourceOption: matchingStepOption
              });
            }
            if (matchingStepOption) {
              matchingStepOption.classList.add('is-selected');
            }
          } else {
            activeFilterItems = activeFilterItems.filter(function (item) {
              return !(item.sid === sid && (item.value === rawVal || item.label === rawLabel));
            });
            if (matchingStepOption) {
              matchingStepOption.classList.remove('is-selected');
            }
          }

          applyFiltersAndRender();
        });
      });

      var groupToggles = root.querySelectorAll('[data-sidebar-group-toggle]');
      Array.prototype.forEach.call(groupToggles, function (toggle) {
        toggle.addEventListener('click', function () {
          var group = toggle.closest('[data-sidebar-group]');
          if (group) {
            var isOpen = group.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          }
        });
      });

      var mobileToggleBtn = root.querySelector('[data-quiz-mobile-filter-toggle]');
      var mobileCloseBtn = root.querySelector('[data-quiz-mobile-filter-close]');
      var mobileBackdrop = root.querySelector('[data-quiz-mobile-filter-backdrop]');
      var sidebar = root.querySelector('[data-quiz-sidebar]');

      function openSidebar() {
        if (sidebar) sidebar.classList.add('is-open');
        if (mobileBackdrop) mobileBackdrop.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }

      function closeSidebar() {
        if (sidebar) sidebar.classList.remove('is-open');
        if (mobileBackdrop) mobileBackdrop.classList.remove('is-active');
        document.body.style.overflow = '';
      }

      if (mobileToggleBtn) mobileToggleBtn.addEventListener('click', openSidebar);
      if (mobileCloseBtn) mobileCloseBtn.addEventListener('click', closeSidebar);
      if (mobileBackdrop) mobileBackdrop.addEventListener('click', closeSidebar);
    }

    /* =========================================================================
       5. ADVANCED METAFIELD & ATTRIBUTE PRODUCT FILTERING
       ========================================================================= */

    function isPriceFilter(val) {
      return /under|\$|\d+\s*–|\d+\s*-\s*\$|\bprice\b/i.test(val);
    }

    function matchesPriceRange(price, val) {
      var p = parseFloat(price);
      if (isNaN(p)) return true;
      val = val.toLowerCase();
      if (val.indexOf('under 5') !== -1 || val.indexOf('less than 5') !== -1) return p < 5;
      if (val.indexOf('under 10') !== -1 || val.indexOf('less than 10') !== -1) return p < 10;
      if (val.indexOf('under 20') !== -1 || val.indexOf('less than 20') !== -1 || val.indexOf('less than $20') !== -1) return p < 20;
      if (val.indexOf('5') !== -1 && val.indexOf('15') !== -1) return p >= 5 && p <= 15;
      if (val.indexOf('15') !== -1 && val.indexOf('30') !== -1) return p >= 15 && p <= 30;
      if (val.indexOf('30') !== -1 && val.indexOf('60') !== -1) return p >= 30 && p <= 60;
      if (val.indexOf('60') !== -1) return p >= 60;
      return true;
    }

    /* Checks if needle matches directly in metafield values */
    function checkMetafieldsMatch(customMeta, needle, category) {
      if (!customMeta) return false;
      var cleanNeedle = needle.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      if (!cleanNeedle) return false;

      function matchVal(val) {
        if (!val) return false;
        if (typeof val === 'string' || typeof val === 'number') {
          var str = String(val).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
          if (str.indexOf(cleanNeedle) !== -1 || cleanNeedle.indexOf(str) !== -1) return true;
          var needleWords = cleanNeedle.split(' ').filter(function(w) { return w.length > 2; });
          for (var i = 0; i < needleWords.length; i++) {
            if (str.indexOf(needleWords[i]) !== -1) return true;
          }
        } else if (Array.isArray(val)) {
          for (var j = 0; j < val.length; j++) {
            if (matchVal(val[j])) return true;
          }
        } else if (typeof val === 'object') {
          for (var k in val) {
            if (val.hasOwnProperty(k) && matchVal(val[k])) return true;
          }
        }
        return false;
      }

      // 1. Direct key inspection based on exact metafield definitions from admin
      if (category === 'Pattern') {
        if (matchVal(customMeta.pattern) || matchVal(customMeta.patterns) || matchVal(customMeta.print) || matchVal(customMeta.design) || matchVal(customMeta.texture)) return true;
      }

      if (category === 'Fabric Type') {
        if (matchVal(customMeta.fabric_type) || matchVal(customMeta.fabric) || matchVal(customMeta.type) || matchVal(customMeta.material) || matchVal(customMeta.content) || matchVal(customMeta.composition) || matchVal(customMeta.fabric_structure)) return true;
      }

      if (category === 'Color Family') {
        if (matchVal(customMeta.color_family) || matchVal(customMeta.color) || matchVal(customMeta.colors) || matchVal(customMeta.shade) || matchVal(customMeta.hue)) return true;
      }

      if (category === 'Projects') {
        if (matchVal(customMeta.project_garment_type) || matchVal(customMeta.garment) || matchVal(customMeta.project) || matchVal(customMeta.project___garment_type) || matchVal(customMeta.what_you_can_make_1st) || matchVal(customMeta.what_you_can_make_2nd) || matchVal(customMeta.what_you_can_make_3rd) || matchVal(customMeta.what_you_can_make_4th)) return true;
      }

      if (category === 'Stretch Level') {
        if (matchVal(customMeta.stretch_level) || matchVal(customMeta.stretch)) return true;
      }

      if (category === 'Weight') {
        if (matchVal(customMeta.weight)) return true;
      }

      if (category === 'Skill Level') {
        if (matchVal(customMeta.skill_level)) return true;
      }

      if (category === 'Drape') {
        if (matchVal(customMeta.drape)) return true;
      }

      if (category === 'Embellishment') {
        if (matchVal(customMeta.embellishment) || matchVal(customMeta.embellishments) || matchVal(customMeta.embellished) || matchVal(customMeta.details) || matchVal(customMeta.specialty) || matchVal(customMeta.features)) return true;
      }

      if (category === 'Opacity') {
        if (matchVal(customMeta.opacity) || matchVal(customMeta.transparency) || matchVal(customMeta.sheerness) || matchVal(customMeta.fabric_opacity)) return true;
      }

      // 2. Full deep scan across all custom metafield keys
      for (var key in customMeta) {
        if (customMeta.hasOwnProperty(key) && customMeta[key]) {
          if (matchVal(customMeta[key])) return true;
        }
      }

      return false;
    }

    function getProductFilterMatchScore(product, item) {
      if (item.isSlider) {
        return 1;
      }

      var needle = (item.value || item.label || '').trim().toLowerCase();
      if (!needle) return 1;

      var prodPrice = parseFloat(product.variants && product.variants[0] ? product.variants[0].price : product.price) || 0;

      if (isPriceFilter(needle) || item.category === 'Price Range') {
        return matchesPriceRange(prodPrice, needle) ? 2 : 0;
      }

      var metaData = productMetafieldsMap[product.handle] || {};
      var customMeta = metaData.custom || {};

      // 1. Direct authentic Metafield Match (Highest Priority Score = 4)
      if (checkMetafieldsMatch(customMeta, needle, item.category)) {
        return 4;
      }

      // Build text corpus
      var metaText = '';
      for (var mk in customMeta) {
        if (customMeta.hasOwnProperty(mk) && customMeta[mk]) {
          var mv = customMeta[mk];
          metaText += ' ' + (typeof mv === 'object' ? JSON.stringify(mv) : String(mv));
        }
      }

      var prodTags = product.tags ? (Array.isArray(product.tags) ? product.tags : [product.tags]) : (metaData.tags || []);
      var prodTagsText = prodTags.join(' ').toLowerCase();
      var prodTitle = (product.title || metaData.title || '').toLowerCase();
      var prodType = (product.product_type || metaData.type || '').toLowerCase();
      var prodDesc = (product.body_html || '').toLowerCase();

      // Check direct Tag match (Priority Score = 3)
      for (var ti = 0; ti < prodTags.length; ti++) {
        var t = String(prodTags[ti]).toLowerCase();
        if (t === needle || t.indexOf(needle) !== -1 || needle.indexOf(t) !== -1) {
          return 3;
        }
      }

      // Check Title match (Priority Score = 3)
      if (prodTitle.indexOf(needle) !== -1) {
        return 3;
      }

      var fullCorpus = prodTitle + ' ' + prodType + ' ' + prodTagsText + ' ' + metaText.toLowerCase() + ' ' + prodDesc;

      // Direct exact or substring match in corpus
      if (fullCorpus.indexOf(needle) !== -1) return 2;

      // 2. Pattern Matching Logic & Synonyms
      if (item.category === 'Pattern') {
        if (needle === 'floral' && (fullCorpus.indexOf('floral') !== -1 || fullCorpus.indexOf('flower') !== -1 || fullCorpus.indexOf('blossom') !== -1 || fullCorpus.indexOf('botanical') !== -1 || fullCorpus.indexOf('rose') !== -1)) return 2;
        if (needle === 'animal print' && (fullCorpus.indexOf('animal') !== -1 || fullCorpus.indexOf('leopard') !== -1 || fullCorpus.indexOf('cheetah') !== -1 || fullCorpus.indexOf('zebra') !== -1 || fullCorpus.indexOf('tiger') !== -1 || fullCorpus.indexOf('snake') !== -1 || fullCorpus.indexOf('python') !== -1 || fullCorpus.indexOf('croc') !== -1 || fullCorpus.indexOf('cow print') !== -1)) return 2;
        if (needle.indexOf('polka') !== -1 || needle.indexOf('circle') !== -1 || needle.indexOf('dot') !== -1) {
          if (fullCorpus.indexOf('polka') !== -1 || fullCorpus.indexOf('dot') !== -1 || fullCorpus.indexOf('circle') !== -1 || fullCorpus.indexOf('spotted') !== -1 || fullCorpus.indexOf('swiss dot') !== -1) return 2;
        }
        if (needle.indexOf('stripe') !== -1) {
          if (fullCorpus.indexOf('stripe') !== -1 || fullCorpus.indexOf('striped') !== -1 || fullCorpus.indexOf('pinstripe') !== -1 || fullCorpus.indexOf('lines') !== -1 || fullCorpus.indexOf('chevron') !== -1) return 2;
        }
        if (needle === 'solid') {
          if (fullCorpus.indexOf('solid') !== -1 || fullCorpus.indexOf('plain') !== -1 || fullCorpus.indexOf('monochrome') !== -1 || fullCorpus.indexOf('single tone') !== -1) return 2;
        }
        if (needle === 'plaid' || needle === 'checkered') {
          if (fullCorpus.indexOf('plaid') !== -1 || fullCorpus.indexOf('check') !== -1 || fullCorpus.indexOf('tartan') !== -1 || fullCorpus.indexOf('gingham') !== -1 || fullCorpus.indexOf('houndstooth') !== -1) return 2;
        }
        if (needle.indexOf('tie dye') !== -1 || needle.indexOf('tie-dye') !== -1) {
          if (fullCorpus.indexOf('tie dye') !== -1 || fullCorpus.indexOf('tie-dye') !== -1 || fullCorpus.indexOf('dyed') !== -1 || fullCorpus.indexOf('shibori') !== -1 || fullCorpus.indexOf('dip dye') !== -1) return 2;
        }
        if (needle === 'sequin') {
          if (fullCorpus.indexOf('sequin') !== -1 || fullCorpus.indexOf('glitter') !== -1 || fullCorpus.indexOf('sparkle') !== -1 || fullCorpus.indexOf('shimmer') !== -1) return 2;
        }
        if (needle === 'abstract') {
          if (fullCorpus.indexOf('abstract') !== -1 || fullCorpus.indexOf('geometric') !== -1 || fullCorpus.indexOf('artistic') !== -1 || fullCorpus.indexOf('modern') !== -1) return 2;
        }
        if (needle.indexOf('damask') !== -1 || needle.indexOf('jacquard') !== -1) {
          if (fullCorpus.indexOf('damask') !== -1 || fullCorpus.indexOf('jacquard') !== -1 || fullCorpus.indexOf('brocade') !== -1 || fullCorpus.indexOf('tapestry') !== -1) return 2;
        }
        if (needle === 'paisley' && fullCorpus.indexOf('paisley') !== -1) return 2;
        if (needle.indexOf('ombr') !== -1 && (fullCorpus.indexOf('ombr') !== -1 || fullCorpus.indexOf('gradient') !== -1 || fullCorpus.indexOf('dip dye') !== -1)) return 2;
        if (needle === 'pleated' && (fullCorpus.indexOf('pleat') !== -1 || fullCorpus.indexOf('pleated') !== -1 || fullCorpus.indexOf('accordion') !== -1)) return 2;
        if (needle === 'crinkled' && (fullCorpus.indexOf('crinkle') !== -1 || fullCorpus.indexOf('wrinkle') !== -1 || fullCorpus.indexOf('crepe') !== -1)) return 2;
        if (needle.indexOf('camo') !== -1 || needle.indexOf('nature') !== -1) {
          if (fullCorpus.indexOf('camo') !== -1 || fullCorpus.indexOf('camouflage') !== -1 || fullCorpus.indexOf('nature') !== -1 || fullCorpus.indexOf('leaf') !== -1 || fullCorpus.indexOf('tree') !== -1) return 2;
        }
        if (needle.indexOf('metallic') !== -1 || needle.indexOf('foil') !== -1) {
          if (fullCorpus.indexOf('metallic') !== -1 || fullCorpus.indexOf('foil') !== -1 || fullCorpus.indexOf('lurex') !== -1 || fullCorpus.indexOf('glitter') !== -1 || fullCorpus.indexOf('shiny') !== -1) return 2;
        }
      }

      // 3. Embellishment Synonyms & Metafield matching
      if (item.category === 'Embellishment') {
        if (needle === 'none' || needle === 'no embellishment' || needle === 'plain') {
          if (fullCorpus.indexOf('embellish') === -1 && fullCorpus.indexOf('sequin') === -1 && fullCorpus.indexOf('bead') === -1 && fullCorpus.indexOf('glitter') === -1 && fullCorpus.indexOf('embroid') === -1 && fullCorpus.indexOf('rhinestone') === -1 && fullCorpus.indexOf('pearl') === -1 && fullCorpus.indexOf('crystal') === -1 && fullCorpus.indexOf('foil') === -1 && fullCorpus.indexOf('metallic print') === -1) return 2;
          if (fullCorpus.indexOf('plain') !== -1 || fullCorpus.indexOf('solid') !== -1 || fullCorpus.indexOf('basic') !== -1) return 2;
        }
        if (needle.indexOf('3d') !== -1 || needle.indexOf('element') !== -1) {
          if (fullCorpus.indexOf('3d') !== -1 || fullCorpus.indexOf('applique') !== -1 || fullCorpus.indexOf('appliques') !== -1 || fullCorpus.indexOf('raised') !== -1 || fullCorpus.indexOf('textured floral') !== -1 || fullCorpus.indexOf('petal') !== -1) return 2;
        }
        if (needle === 'beaded' || needle.indexOf('bead') !== -1) {
          if (fullCorpus.indexOf('bead') !== -1 || fullCorpus.indexOf('beaded') !== -1 || fullCorpus.indexOf('beading') !== -1 || fullCorpus.indexOf('seed bead') !== -1) return 2;
        }
        if (needle.indexOf('bugle') !== -1) {
          if (fullCorpus.indexOf('bugle') !== -1 || fullCorpus.indexOf('glass bead') !== -1 || fullCorpus.indexOf('bead') !== -1 || fullCorpus.indexOf('tube bead') !== -1) return 2;
        }
        if (needle === 'crystal' || needle.indexOf('crystal') !== -1) {
          if (fullCorpus.indexOf('crystal') !== -1 || fullCorpus.indexOf('crystals') !== -1 || fullCorpus.indexOf('glass stone') !== -1 || fullCorpus.indexOf('rhinestone') !== -1 || fullCorpus.indexOf('swarovski') !== -1) return 2;
        }
        if (needle === 'embroidery' || needle.indexOf('embroid') !== -1) {
          if (fullCorpus.indexOf('embroid') !== -1 || fullCorpus.indexOf('embroidery') !== -1 || fullCorpus.indexOf('embroidered') !== -1 || fullCorpus.indexOf('threadwork') !== -1 || fullCorpus.indexOf('needlework') !== -1) return 2;
        }
        if (needle.indexOf('foil') !== -1 || needle.indexOf('metallic print') !== -1) {
          if (fullCorpus.indexOf('foil') !== -1 || fullCorpus.indexOf('metallic print') !== -1 || fullCorpus.indexOf('metallic') !== -1 || fullCorpus.indexOf('lurex') !== -1 || fullCorpus.indexOf('gold print') !== -1 || fullCorpus.indexOf('silver print') !== -1 || fullCorpus.indexOf('shimmer print') !== -1) return 2;
        }
        if (needle === 'glitter' || needle.indexOf('glitter') !== -1) {
          if (fullCorpus.indexOf('glitter') !== -1 || fullCorpus.indexOf('sparkle') !== -1 || fullCorpus.indexOf('shimmer') !== -1 || fullCorpus.indexOf('dust') !== -1) return 2;
        }
        if (needle === 'pearl' || needle.indexOf('pearl') !== -1) {
          if (fullCorpus.indexOf('pearl') !== -1 || fullCorpus.indexOf('pearls') !== -1 || fullCorpus.indexOf('pearlescent') !== -1 || fullCorpus.indexOf('faux pearl') !== -1) return 2;
        }
        if (needle === 'rhinestones' || needle.indexOf('rhinestone') !== -1) {
          if (fullCorpus.indexOf('rhinestone') !== -1 || fullCorpus.indexOf('rhinestones') !== -1 || fullCorpus.indexOf('diamante') !== -1 || fullCorpus.indexOf('crystal') !== -1 || fullCorpus.indexOf('gem') !== -1 || fullCorpus.indexOf('stone') !== -1) return 2;
        }
        if (needle === 'sequins' || needle.indexOf('sequin') !== -1) {
          if (fullCorpus.indexOf('sequin') !== -1 || fullCorpus.indexOf('sequins') !== -1 || fullCorpus.indexOf('paillette') !== -1 || fullCorpus.indexOf('payette') !== -1 || fullCorpus.indexOf('spangle') !== -1) return 2;
        }
      }

      // 4. Fabric Type Synonyms
      if (item.category === 'Fabric Type') {
        if (needle === 'cotton' && (fullCorpus.indexOf('cotton') !== -1 || fullCorpus.indexOf('poplin') !== -1 || fullCorpus.indexOf('lawn') !== -1 || fullCorpus.indexOf('voile') !== -1 || fullCorpus.indexOf('sateen') !== -1)) return 2;
        if (needle === 'silk' && (fullCorpus.indexOf('silk') !== -1 || fullCorpus.indexOf('habotai') !== -1 || fullCorpus.indexOf('charmeuse') !== -1 || fullCorpus.indexOf('dupioni') !== -1)) return 2;
        if (needle === 'satin' && (fullCorpus.indexOf('satin') !== -1 || fullCorpus.indexOf('charmeuse') !== -1 || fullCorpus.indexOf('duchess') !== -1)) return 2;
        if (needle === 'linen' && (fullCorpus.indexOf('linen') !== -1 || fullCorpus.indexOf('flax') !== -1)) return 2;
        if (needle === 'chiffon' && (fullCorpus.indexOf('chiffon') !== -1 || fullCorpus.indexOf('georgette') !== -1)) return 2;
        if (needle === 'velvet' && (fullCorpus.indexOf('velvet') !== -1 || fullCorpus.indexOf('velour') !== -1)) return 2;
        if (needle === 'denim' && (fullCorpus.indexOf('denim') !== -1 || fullCorpus.indexOf('jean') !== -1 || fullCorpus.indexOf('chambray') !== -1)) return 2;
        if (needle === 'wool' && (fullCorpus.indexOf('wool') !== -1 || fullCorpus.indexOf('cashmere') !== -1 || fullCorpus.indexOf('merino') !== -1)) return 2;
        if (needle === 'lace' && (fullCorpus.indexOf('lace') !== -1 || fullCorpus.indexOf('guipure') !== -1 || fullCorpus.indexOf('chantilly') !== -1)) return 2;
        if (needle === 'organza' && (fullCorpus.indexOf('organza') !== -1 || fullCorpus.indexOf('sheer') !== -1)) return 2;
        if (needle === 'tulle' && (fullCorpus.indexOf('tulle') !== -1 || fullCorpus.indexOf('netting') !== -1)) return 2;
        if (needle === 'mesh' && (fullCorpus.indexOf('mesh') !== -1 || fullCorpus.indexOf('power mesh') !== -1 || fullCorpus.indexOf('net') !== -1)) return 2;
        if (needle === 'rayon' && (fullCorpus.indexOf('rayon') !== -1 || fullCorpus.indexOf('viscose') !== -1 || fullCorpus.indexOf('modal') !== -1 || fullCorpus.indexOf('tencel') !== -1)) return 2;
        if (needle.indexOf('spandex') !== -1 || needle.indexOf('activewear') !== -1) {
          if (fullCorpus.indexOf('spandex') !== -1 || fullCorpus.indexOf('lycra') !== -1 || fullCorpus.indexOf('elastane') !== -1 || fullCorpus.indexOf('activewear') !== -1 || fullCorpus.indexOf('athletic') !== -1) return 2;
        }
        if (needle.indexOf('crepe') !== -1 || needle.indexOf('gabardine') !== -1) {
          if (fullCorpus.indexOf('crepe') !== -1 || fullCorpus.indexOf('gabardine') !== -1 || fullCorpus.indexOf('scuba crepe') !== -1) return 2;
        }
        if (needle.indexOf('suiting') !== -1 || needle.indexOf('twill') !== -1) {
          if (fullCorpus.indexOf('suiting') !== -1 || fullCorpus.indexOf('twill') !== -1 || fullCorpus.indexOf('gabardine') !== -1) return 2;
        }
        if (needle === 'tweed' && (fullCorpus.indexOf('tweed') !== -1 || fullCorpus.indexOf('boucle') !== -1)) return 2;
        if (needle.indexOf('faux fur') !== -1 && (fullCorpus.indexOf('fur') !== -1 || fullCorpus.indexOf('sherpa') !== -1 || fullCorpus.indexOf('fleece') !== -1)) return 2;
        if (needle.indexOf('faux leather') !== -1 && (fullCorpus.indexOf('leather') !== -1 || fullCorpus.indexOf('pleather') !== -1 || fullCorpus.indexOf('vinyl') !== -1 || fullCorpus.indexOf('pu leather') !== -1)) return 2;
        if (needle.indexOf('metallic') !== -1 || needle.indexOf('lurex') !== -1) {
          if (fullCorpus.indexOf('metallic') !== -1 || fullCorpus.indexOf('lurex') !== -1 || fullCorpus.indexOf('lamé') !== -1 || fullCorpus.indexOf('lame') !== -1 || fullCorpus.indexOf('foil') !== -1) return 2;
        }
      }

      // 5. Color Family Synonyms
      if (item.category === 'Color Family') {
        if (needle.indexOf('beige') !== -1 || needle.indexOf('nude') !== -1 || needle.indexOf('tan') !== -1) {
          if (fullCorpus.indexOf('beige') !== -1 || fullCorpus.indexOf('nude') !== -1 || fullCorpus.indexOf('tan') !== -1 || fullCorpus.indexOf('sand') !== -1 || fullCorpus.indexOf('camel') !== -1 || fullCorpus.indexOf('taupe') !== -1 || fullCorpus.indexOf('khaki') !== -1 || fullCorpus.indexOf('neutral') !== -1) return 2;
        }
        if (needle.indexOf('ivory') !== -1 || needle.indexOf('cream') !== -1) {
          if (fullCorpus.indexOf('ivory') !== -1 || fullCorpus.indexOf('cream') !== -1 || fullCorpus.indexOf('off white') !== -1 || fullCorpus.indexOf('off-white') !== -1 || fullCorpus.indexOf('bone') !== -1 || fullCorpus.indexOf('vanilla') !== -1 || fullCorpus.indexOf('pearl') !== -1 || fullCorpus.indexOf('ecru') !== -1) return 2;
        }
        if (needle === 'black' && (fullCorpus.indexOf('black') !== -1 || fullCorpus.indexOf('noir') !== -1 || fullCorpus.indexOf('ebony') !== -1)) return 2;
        if (needle === 'white' && (fullCorpus.indexOf('white') !== -1 || fullCorpus.indexOf('snow') !== -1 || fullCorpus.indexOf('blanc') !== -1)) return 2;
        if (needle === 'blue' && (fullCorpus.indexOf('blue') !== -1 || fullCorpus.indexOf('navy') !== -1 || fullCorpus.indexOf('royal') !== -1 || fullCorpus.indexOf('sky') !== -1 || fullCorpus.indexOf('teal') !== -1 || fullCorpus.indexOf('cobalt') !== -1 || fullCorpus.indexOf('aqua') !== -1 || fullCorpus.indexOf('turquoise') !== -1 || fullCorpus.indexOf('indigo') !== -1 || fullCorpus.indexOf('denim') !== -1)) return 2;
        if (needle === 'red' && (fullCorpus.indexOf('red') !== -1 || fullCorpus.indexOf('crimson') !== -1 || fullCorpus.indexOf('ruby') !== -1 || fullCorpus.indexOf('scarlet') !== -1 || fullCorpus.indexOf('cherry') !== -1)) return 2;
        if (needle === 'burgundy' && (fullCorpus.indexOf('burgundy') !== -1 || fullCorpus.indexOf('maroon') !== -1 || fullCorpus.indexOf('wine') !== -1 || fullCorpus.indexOf('bordeaux') !== -1 || fullCorpus.indexOf('oxblood') !== -1)) return 2;
        if (needle === 'pink' && (fullCorpus.indexOf('pink') !== -1 || fullCorpus.indexOf('blush') !== -1 || fullCorpus.indexOf('rose') !== -1 || fullCorpus.indexOf('fuchsia') !== -1 || fullCorpus.indexOf('magenta') !== -1)) return 2;
        if (needle === 'green' && (fullCorpus.indexOf('green') !== -1 || fullCorpus.indexOf('emerald') !== -1 || fullCorpus.indexOf('olive') !== -1 || fullCorpus.indexOf('sage') !== -1 || fullCorpus.indexOf('mint') !== -1 || fullCorpus.indexOf('forest') !== -1 || fullCorpus.indexOf('hunter') !== -1)) return 2;
        if (needle === 'yellow' && (fullCorpus.indexOf('yellow') !== -1 || fullCorpus.indexOf('lemon') !== -1 || fullCorpus.indexOf('mustard') !== -1 || fullCorpus.indexOf('canary') !== -1)) return 2;
        if (needle === 'gold' && (fullCorpus.indexOf('gold') !== -1 || fullCorpus.indexOf('golden') !== -1 || fullCorpus.indexOf('champagne gold') !== -1)) return 2;
        if (needle === 'silver' && (fullCorpus.indexOf('silver') !== -1 || fullCorpus.indexOf('metallic silver') !== -1 || fullCorpus.indexOf('gray silver') !== -1)) return 2;
        if (needle === 'gray' || needle === 'grey') {
          if (fullCorpus.indexOf('gray') !== -1 || fullCorpus.indexOf('grey') !== -1 || fullCorpus.indexOf('charcoal') !== -1 || fullCorpus.indexOf('slate') !== -1 || fullCorpus.indexOf('ash') !== -1 || fullCorpus.indexOf('silver') !== -1) return 2;
        }
        if (needle === 'purple' && (fullCorpus.indexOf('purple') !== -1 || fullCorpus.indexOf('violet') !== -1 || fullCorpus.indexOf('lavender') !== -1 || fullCorpus.indexOf('lilac') !== -1 || fullCorpus.indexOf('plum') !== -1 || fullCorpus.indexOf('eggplant') !== -1)) return 2;
        if (needle === 'orange' && (fullCorpus.indexOf('orange') !== -1 || fullCorpus.indexOf('rust') !== -1 || fullCorpus.indexOf('terracotta') !== -1 || fullCorpus.indexOf('peach') !== -1 || fullCorpus.indexOf('tangerine') !== -1)) return 2;
        if (needle === 'brown' && (fullCorpus.indexOf('brown') !== -1 || fullCorpus.indexOf('chocolate') !== -1 || fullCorpus.indexOf('mocha') !== -1 || fullCorpus.indexOf('espresso') !== -1 || fullCorpus.indexOf('cognac') !== -1)) return 2;
        if (needle === 'coral' && (fullCorpus.indexOf('coral') !== -1 || fullCorpus.indexOf('salmon') !== -1 || fullCorpus.indexOf('peach') !== -1)) return 2;
        if (needle === 'champagne' && (fullCorpus.indexOf('champagne') !== -1 || fullCorpus.indexOf('prosecco') !== -1)) return 2;
        if (needle.indexOf('multi') !== -1 || needle.indexOf('rainbow') !== -1) {
          if (fullCorpus.indexOf('multi') !== -1 || fullCorpus.indexOf('multicolor') !== -1 || fullCorpus.indexOf('multicolored') !== -1 || fullCorpus.indexOf('rainbow') !== -1 || fullCorpus.indexOf('print') !== -1 || fullCorpus.indexOf('floral') !== -1 || fullCorpus.indexOf('stripe') !== -1) return 2;
        }
      }

      // 6. Stretch Level Synonyms
      if (item.category === 'Stretch Level' || needle.indexOf('stretch') !== -1) {
        if (needle.indexOf('non-stretch') !== -1 || needle.indexOf('non stretch') !== -1) {
          if (fullCorpus.indexOf('non-stretch') !== -1 || fullCorpus.indexOf('non stretch') !== -1 || fullCorpus.indexOf('rigid') !== -1 || fullCorpus.indexOf('100% cotton') !== -1 || fullCorpus.indexOf('100% polyester') !== -1) return 2;
          if (fullCorpus.indexOf('stretch') === -1 && fullCorpus.indexOf('spandex') === -1 && fullCorpus.indexOf('lycra') === -1 && fullCorpus.indexOf('elastane') === -1) return 2;
        }
        if (needle.indexOf('4-way') !== -1 || needle.indexOf('4 way') !== -1) {
          if (fullCorpus.indexOf('4-way') !== -1 || fullCorpus.indexOf('4 way') !== -1 || fullCorpus.indexOf('four way') !== -1 || fullCorpus.indexOf('spandex') !== -1 || fullCorpus.indexOf('stretch') !== -1) return 2;
        }
        if (needle.indexOf('2-way') !== -1 || needle.indexOf('2 way') !== -1) {
          if (fullCorpus.indexOf('2-way') !== -1 || fullCorpus.indexOf('2 way') !== -1 || fullCorpus.indexOf('two way') !== -1 || fullCorpus.indexOf('stretch') !== -1) return 2;
        }
        if (fullCorpus.indexOf('stretch') !== -1 || fullCorpus.indexOf('spandex') !== -1 || fullCorpus.indexOf('lycra') !== -1 || fullCorpus.indexOf('elastane') !== -1) return 2;
      }

      // 7. Weight Synonyms
      if (item.category === 'Weight') {
        if (needle.indexOf('heavy') !== -1 && (fullCorpus.indexOf('heavy') !== -1 || fullCorpus.indexOf('coat') !== -1 || fullCorpus.indexOf('jacket') !== -1 || fullCorpus.indexOf('denim') !== -1 || fullCorpus.indexOf('wool') !== -1 || fullCorpus.indexOf('canvas') !== -1)) return 2;
        if (needle.indexOf('light') !== -1 && (fullCorpus.indexOf('light') !== -1 || fullCorpus.indexOf('chiffon') !== -1 || fullCorpus.indexOf('organza') !== -1 || fullCorpus.indexOf('mesh') !== -1 || fullCorpus.indexOf('silk') !== -1 || fullCorpus.indexOf('voile') !== -1)) return 2;
        if (needle.indexOf('medium') !== -1 && (fullCorpus.indexOf('medium') !== -1 || fullCorpus.indexOf('satin') !== -1 || fullCorpus.indexOf('cotton') !== -1 || fullCorpus.indexOf('crepe') !== -1 || fullCorpus.indexOf('linen') !== -1)) return 2;
      }

      // 8. Projects / Garment Synonyms
      if (item.category === 'Projects') {
        if (needle === 'activewear' && (fullCorpus.indexOf('active') !== -1 || fullCorpus.indexOf('spandex') !== -1 || fullCorpus.indexOf('athletic') !== -1 || fullCorpus.indexOf('gym') !== -1 || fullCorpus.indexOf('yoga') !== -1)) return 2;
        if (needle === 'bridal' && (fullCorpus.indexOf('bridal') !== -1 || fullCorpus.indexOf('wedding') !== -1 || fullCorpus.indexOf('bride') !== -1 || fullCorpus.indexOf('lace') !== -1 || fullCorpus.indexOf('satin') !== -1 || fullCorpus.indexOf('chiffon') !== -1 || fullCorpus.indexOf('tulle') !== -1)) return 2;
        if (needle === 'swimwear' && (fullCorpus.indexOf('swim') !== -1 || fullCorpus.indexOf('trilobal') !== -1 || fullCorpus.indexOf('nylon') !== -1 || fullCorpus.indexOf('spandex') !== -1)) return 2;
        if (needle === 'dancewear' && (fullCorpus.indexOf('dance') !== -1 || fullCorpus.indexOf('sequin') !== -1 || fullCorpus.indexOf('glitter') !== -1 || fullCorpus.indexOf('spandex') !== -1 || fullCorpus.indexOf('mesh') !== -1)) return 2;
        if (needle === 'outerwear' && (fullCorpus.indexOf('outerwear') !== -1 || fullCorpus.indexOf('coat') !== -1 || fullCorpus.indexOf('jacket') !== -1 || fullCorpus.indexOf('fleece') !== -1 || fullCorpus.indexOf('wool') !== -1)) return 2;
        if (needle === 'costumes' && (fullCorpus.indexOf('costume') !== -1 || fullCorpus.indexOf('sequin') !== -1 || fullCorpus.indexOf('glitter') !== -1 || fullCorpus.indexOf('hologram') !== -1 || fullCorpus.indexOf('velvet') !== -1)) return 2;
        if (needle === 'couture' && (fullCorpus.indexOf('couture') !== -1 || fullCorpus.indexOf('luxury') !== -1 || fullCorpus.indexOf('embroid') !== -1 || fullCorpus.indexOf('bead') !== -1 || fullCorpus.indexOf('brocade') !== -1)) return 2;
        if (needle === 'loungewear' && (fullCorpus.indexOf('lounge') !== -1 || fullCorpus.indexOf('knit') !== -1 || fullCorpus.indexOf('cotton') !== -1 || fullCorpus.indexOf('modal') !== -1 || fullCorpus.indexOf('rib') !== -1)) return 2;
        if (needle === 'pants' && (fullCorpus.indexOf('pant') !== -1 || fullCorpus.indexOf('trouser') !== -1 || fullCorpus.indexOf('suiting') !== -1 || fullCorpus.indexOf('denim') !== -1 || fullCorpus.indexOf('twill') !== -1)) return 2;
        if (needle === 'suits' && (fullCorpus.indexOf('suit') !== -1 || fullCorpus.indexOf('blazer') !== -1 || fullCorpus.indexOf('wool') !== -1 || fullCorpus.indexOf('gabardine') !== -1)) return 2;
        if (needle === 'tops' && (fullCorpus.indexOf('top') !== -1 || fullCorpus.indexOf('shirt') !== -1 || fullCorpus.indexOf('blouse') !== -1 || fullCorpus.indexOf('tee') !== -1 || fullCorpus.indexOf('knit') !== -1)) return 2;
        if (needle === 'dresses' && (fullCorpus.indexOf('dress') !== -1 || fullCorpus.indexOf('gown') !== -1 || fullCorpus.indexOf('satin') !== -1 || fullCorpus.indexOf('silk') !== -1 || fullCorpus.indexOf('chiffon') !== -1)) return 2;
      }

      // 9. Drape Synonyms & Metafield matching
      if (item.category === 'Drape') {
        if (needle === 'fluid' || needle.indexOf('flow') !== -1 || needle.indexOf('fluid') !== -1) {
          if (fullCorpus.indexOf('fluid') !== -1 || fullCorpus.indexOf('flowy') !== -1 || fullCorpus.indexOf('flowing') !== -1 || fullCorpus.indexOf('drapey') !== -1 || fullCorpus.indexOf('liquid') !== -1 || fullCorpus.indexOf('soft drape') !== -1 || fullCorpus.indexOf('chiffon') !== -1 || fullCorpus.indexOf('georgette') !== -1 || fullCorpus.indexOf('rayon') !== -1 || fullCorpus.indexOf('silk') !== -1) return 2;
        }
        if (needle === 'moderate' || needle.indexOf('medium') !== -1 || needle.indexOf('moderate') !== -1) {
          if (fullCorpus.indexOf('moderate') !== -1 || fullCorpus.indexOf('medium drape') !== -1 || fullCorpus.indexOf('cotton') !== -1 || fullCorpus.indexOf('linen') !== -1 || fullCorpus.indexOf('crepe') !== -1 || fullCorpus.indexOf('satin') !== -1 || fullCorpus.indexOf('poplin') !== -1) return 2;
        }
        if (needle === 'structured' || needle.indexOf('stiff') !== -1 || needle.indexOf('structur') !== -1) {
          if (fullCorpus.indexOf('structured') !== -1 || fullCorpus.indexOf('structure') !== -1 || fullCorpus.indexOf('stiff') !== -1 || fullCorpus.indexOf('crisp') !== -1 || fullCorpus.indexOf('firm') !== -1 || fullCorpus.indexOf('taffeta') !== -1 || fullCorpus.indexOf('organza') !== -1 || fullCorpus.indexOf('brocade') !== -1 || fullCorpus.indexOf('denim') !== -1 || fullCorpus.indexOf('canvas') !== -1 || fullCorpus.indexOf('twill') !== -1 || fullCorpus.indexOf('heavy') !== -1) return 2;
        }
      }

      // 10. Opacity Synonyms & Metafield matching
      if (item.category === 'Opacity') {
        if (needle === 'opaque' || needle.indexOf('non-sheer') !== -1 || needle.indexOf('solid') !== -1) {
          if (fullCorpus.indexOf('opaque') !== -1 || fullCorpus.indexOf('non-sheer') !== -1 || fullCorpus.indexOf('not sheer') !== -1 || fullCorpus.indexOf('solid') !== -1 || fullCorpus.indexOf('thick') !== -1 || fullCorpus.indexOf('full coverage') !== -1 || fullCorpus.indexOf('no lining') !== -1) return 2;
          if (fullCorpus.indexOf('sheer') === -1 && fullCorpus.indexOf('chiffon') === -1 && fullCorpus.indexOf('organza') === -1 && fullCorpus.indexOf('tulle') === -1 && fullCorpus.indexOf('mesh') === -1) return 2;
        }
        if (needle.indexOf('semi-sheer') !== -1 || needle.indexOf('semi sheer') !== -1 || needle.indexOf('semi') !== -1) {
          if (fullCorpus.indexOf('semi-sheer') !== -1 || fullCorpus.indexOf('semi sheer') !== -1 || fullCorpus.indexOf('semi-transparent') !== -1 || fullCorpus.indexOf('semi transparent') !== -1 || fullCorpus.indexOf('slightly sheer') !== -1 || fullCorpus.indexOf('burnout') !== -1 || fullCorpus.indexOf('linen') !== -1 || fullCorpus.indexOf('georgette') !== -1) return 2;
        }
        if (needle === 'sheer' || needle.indexOf('transparent') !== -1 || needle.indexOf('see-through') !== -1) {
          if (fullCorpus.indexOf('sheer') !== -1 || fullCorpus.indexOf('see-through') !== -1 || fullCorpus.indexOf('see through') !== -1 || fullCorpus.indexOf('transparent') !== -1 || fullCorpus.indexOf('translucent') !== -1 || fullCorpus.indexOf('chiffon') !== -1 || fullCorpus.indexOf('organza') !== -1 || fullCorpus.indexOf('tulle') !== -1 || fullCorpus.indexOf('mesh') !== -1 || fullCorpus.indexOf('voile') !== -1 || fullCorpus.indexOf('net') !== -1) return 2;
        }
      }

      // Keyword split (slashes, commas, plus, ampersands)
      var words = needle.split(/[\/,&\+]+/).map(function (w) { return w.trim(); }).filter(Boolean);
      for (var k = 0; k < words.length; k++) {
        var w = words[k];
        if (w.length < 3) continue;
        if (fullCorpus.indexOf(w) !== -1) return 2;
        if (w.length > 3 && w.endsWith('s') && fullCorpus.indexOf(w.slice(0, -1)) !== -1) return 2;
      }

      return 0;
    }

    function filterProductsList(products, filterItems) {
      if (!filterItems.length) return products;

      /* Group filter items by Category */
      var byCategory = {};
      filterItems.forEach(function (item) {
        if (!byCategory[item.category]) byCategory[item.category] = [];
        byCategory[item.category].push(item);
      });

      var catKeys = Object.keys(byCategory);
      var totalCategories = catKeys.length;

      var scored = [];

      products.forEach(function (prod) {
        var score = 0;
        var matchedCats = 0;
        for (var i = 0; i < catKeys.length; i++) {
          var itemsInCat = byCategory[catKeys[i]];
          var bestCatScore = 0;
          for (var j = 0; j < itemsInCat.length; j++) {
            var itemScore = getProductFilterMatchScore(prod, itemsInCat[j]);
            if (itemScore > bestCatScore) {
              bestCatScore = itemScore;
            }
          }
          if (bestCatScore > 0) {
            matchedCats += 1;
            score += bestCatScore; // Metafield match = 4, Tags/Title = 3, Text corpus/synonyms = 2
          }
        }
        if (matchedCats > 0) {
          scored.push({
            product: prod,
            score: score,
            matchedCats: matchedCats,
            isFullMatch: matchedCats === totalCategories
          });
        }
      });

      if (!scored.length) return [];

      /* Sort so products that match ALL selected categories (100% full matches) are at the VERY TOP,
         followed by highest matching scores (metafields priority) */
      scored.sort(function (a, b) {
        if (a.isFullMatch && !b.isFullMatch) return -1;
        if (!a.isFullMatch && b.isFullMatch) return 1;
        if (a.matchedCats !== b.matchedCats) return b.matchedCats - a.matchedCats;
        return b.score - a.score;
      });

      return scored.map(function (s) { return s.product; });
    }

    function sortProducts(products, sortType) {
      var list = products.slice();
      if (sortType === 'price-asc') {
        list.sort(function (a, b) {
          var pA = parseFloat(a.variants && a.variants[0] ? a.variants[0].price : a.price) || 0;
          var pB = parseFloat(b.variants && b.variants[0] ? b.variants[0].price : b.price) || 0;
          return pA - pB;
        });
      } else if (sortType === 'price-desc') {
        list.sort(function (a, b) {
          var pA = parseFloat(a.variants && a.variants[0] ? a.variants[0].price : a.price) || 0;
          var pB = parseFloat(b.variants && b.variants[0] ? b.variants[0].price : b.price) || 0;
          return pB - pA;
        });
      } else if (sortType === 'title-asc') {
        list.sort(function (a, b) {
          return (a.title || '').localeCompare(b.title || '');
        });
      } else if (sortType === 'title-desc') {
        list.sort(function (a, b) {
          return (b.title || '').localeCompare(a.title || '');
        });
      }
      return list;
    }

    function getSizedImageUrl(src, size) {
      if (!src) return '';
      size = size || '600x';
      try {
        var cleanSrc = src.split('?')[0];
        var query = src.indexOf('?') !== -1 ? '?' + src.split('?')[1] : '';
        var extMatch = cleanSrc.match(/\.(jpg|jpeg|png|webp|gif)$/i);
        if (extMatch) {
          var ext = extMatch[0];
          var base = cleanSrc.substring(0, cleanSrc.length - ext.length);
          base = base.replace(/_\d+x(\d+)?$/, '');
          return base + '_' + size + ext + query;
        }
        return src + (query ? '&' : '?') + 'width=600';
      } catch (e) {
        return src;
      }
    }

    function truncateWords(str, count) {
      if (!str) return '';
      var clean = str.trim();
      var words = clean.split(/\s+/);
      if (words.length > count) {
        return words.slice(0, count).join(' ') + '...';
      }
      return clean;
    }

    function renderProductCards(products) {
      if (!productsGridEl) return;
      productsGridEl.innerHTML = '';

      if (!products.length) {
        if (emptyStateEl) emptyStateEl.hidden = false;
        return;
      }
      if (emptyStateEl) emptyStateEl.hidden = true;

      /* Display ALL matching products */
      var displayList = products;

      displayList.forEach(function (prod) {
        var card = document.createElement('div');
        card.className = 'fabric-quiz__product-card';

        var rawImg = (prod.images && prod.images[0] ? prod.images[0].src : (prod.featured_image || ''));
        var rawHoverImg = (prod.images && prod.images[1] ? prod.images[1].src : '');

        var imgUrl = getSizedImageUrl(rawImg, '600x');
        var hoverImgUrl = getSizedImageUrl(rawHoverImg, '600x');

        var prodUrl = '/products/' + prod.handle;
        var variant = prod.variants && prod.variants[0] ? prod.variants[0] : {};
        var priceFormatted = formatMoney(variant.price || prod.price);
        var compareAtFormatted = variant.compare_at_price ? formatMoney(variant.compare_at_price) : '';
        var onSale = variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price);
        var fullTitle = (prod.title || '').replace(/"/g, '&quot;');
        var shortTitle = truncateWords(prod.title, 4);

        card.innerHTML = 
          '<a href="' + prodUrl + '" class="fabric-quiz__product-media">' +
            (onSale ? '<span class="fabric-quiz__product-badge">SALE</span>' : '') +
            (imgUrl ? '<img class="fabric-quiz__product-img' + (hoverImgUrl ? ' has-hover' : '') + '" src="' + imgUrl + '" alt="' + fullTitle + '" loading="lazy" decoding="async">' : '<div class="fabric-quiz__product-placeholder"></div>') +
            (hoverImgUrl ? '<img class="fabric-quiz__product-img-hover" src="' + hoverImgUrl + '" alt="' + fullTitle + '" loading="lazy" decoding="async">' : '') +
          '</a>' +
          '<div class="fabric-quiz__product-info">' +
            (prod.product_type ? '<div class="fabric-quiz__product-type">' + prod.product_type + '</div>' : '') +
            '<h4 class="fabric-quiz__product-title" title="' + fullTitle + '"><a href="' + prodUrl + '">' + shortTitle + '</a></h4>' +
            '<div class="fabric-quiz__product-price-row">' +
              '<span class="fabric-quiz__product-price' + (onSale ? ' is-sale' : '') + '">' + priceFormatted + ' / yd</span>' +
              (onSale && compareAtFormatted ? '<span class="fabric-quiz__product-compare-price">' + compareAtFormatted + '</span>' : '') +
            '</div>' +
            '<a href="' + prodUrl + '" class="fabric-quiz__product-btn">View Fabric</a>' +
          '</div>';

        productsGridEl.appendChild(card);
      });
    }

    function applyFiltersAndRender() {
      renderSidebarPills();
      syncSidebarCheckboxes();

      var filtered = filterProductsList(allProducts, activeFilterItems);
      var sorted = sortProducts(filtered, currentSort);

      if (countTextEl) {
        countTextEl.textContent = sorted.length + ' Results';
      }

      renderProductCards(sorted);
    }

    /* =========================================================================
       6. STEP 5 FORM SUBMIT HANDLER (EMAIL -> SHOW RESULTS)
       ========================================================================= */

    if (form) {
      form.addEventListener('submit', function (e) {
        buildSummary(); /* populate note with quiz selections */

        var emailInput = form.querySelector('input[type="email"]');
        if (emailInput && !emailInput.checkValidity()) {
          return; /* native browser validation */
        }

        e.preventDefault();

        var submitBtn = form.querySelector('.fabric-quiz__submit');
        var originalText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Finding your matches…';
        }

        var action = form.getAttribute('action') || window.location.pathname;

        /* Submit customer lead in background */
        fetch(action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'text/html' }
        })
          .catch(function () {})
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = originalText;
            }
            /* Transition to Search Results & Filter Sidebar */
            triggerShowResults();
          });
      });
    }

    var skipBtns = root.querySelectorAll('[data-quiz-skip]');
    Array.prototype.forEach.call(skipBtns, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        triggerShowResults();
      });
    });

    /* =========================================================================
       7. RESULTS CONTROLS (CUSTOM SORT DROPDOWN, CLEAR ALL, RETAKE)
       ========================================================================= */

    function toggleSortDropdown(show) {
      if (!sortMenuEl || !sortToggleBtn || !sortWrapper) return;
      var isOpen = typeof show === 'boolean' ? show : sortMenuEl.hidden;
      sortMenuEl.hidden = !isOpen;
      sortToggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      sortWrapper.classList.toggle('is-open', isOpen);
    }

    if (sortToggleBtn) {
      sortToggleBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleSortDropdown();
      });
    }

    if (sortOptions && sortOptions.length) {
      Array.prototype.forEach.call(sortOptions, function (opt) {
        opt.addEventListener('click', function (e) {
          e.stopPropagation();
          var val = opt.getAttribute('data-value') || 'featured';
          var textSpan = opt.querySelector('span');
          var labelText = textSpan ? textSpan.textContent.trim() : val;

          currentSort = val;

          if (sortLabelEl) {
            sortLabelEl.textContent = labelText;
          }

          if (sortSelect) {
            sortSelect.value = val;
          }

          Array.prototype.forEach.call(sortOptions, function (o) {
            var isCur = o === opt;
            o.classList.toggle('is-selected', isCur);
            o.setAttribute('aria-selected', isCur ? 'true' : 'false');
          });

          toggleSortDropdown(false);
          applyFiltersAndRender();
        });
      });
    }

    /* Close custom dropdown on outside click or ESC key */
    document.addEventListener('click', function (e) {
      if (sortWrapper && !sortWrapper.contains(e.target)) {
        toggleSortDropdown(false);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        toggleSortDropdown(false);
      }
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        currentSort = sortSelect.value;
        applyFiltersAndRender();
      });
    }

    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', function () {
        activeFilterItems = [];
        var allSelected = root.querySelectorAll('[data-option].is-selected');
        Array.prototype.forEach.call(allSelected, function (el) { el.classList.remove('is-selected'); });
        applyFiltersAndRender();
      });
    }

    if (emptyResetBtn) {
      emptyResetBtn.addEventListener('click', function () {
        activeFilterItems = [];
        var allSelected = root.querySelectorAll('[data-option].is-selected');
        Array.prototype.forEach.call(allSelected, function (el) { el.classList.remove('is-selected'); });
        applyFiltersAndRender();
      });
    }

    if (retakeBtn) {
      retakeBtn.addEventListener('click', function () {
        if (resultsView) resultsView.hidden = true;
        if (quizView) quizView.hidden = false;
        current = 0;
        renderStep(true);
      });
    }

    bindSidebarFilters();

    /* Full-page submit reload handler */
    var qs = window.location.search;
    if (qs.indexOf('customer_posted=true') !== -1 || qs.indexOf('contact_posted=true') !== -1) {
      try {
        var cached = sessionStorage.getItem('fq_active_filters');
        if (cached) {
          activeFilterItems = JSON.parse(cached);
        }
      } catch (e) {}
      if (!activeFilterItems || !activeFilterItems.length) {
        activeFilterItems = collectSelectedFilterItems();
      }
      if (quizView) quizView.hidden = true;
      if (resultsView) resultsView.hidden = false;
      fetchProducts(function () {
        applyFiltersAndRender();
      });
    } else {
      renderStep();
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fabric-quiz]'), initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var quiz = e.target.querySelector('[data-fabric-quiz]');
    if (quiz) initQuiz(quiz);
  });
})();
